<script>
  import { onMount } from "svelte";

  const checkoutUrl = "https://www.launchpass.com/alfa-toro/tge-hero-max";

  const socialProofImages = [
    "https://alfatoro.com/wp-content/uploads/2025/06/4.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/6.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/3.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/Untitled-design-2.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/2.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/5.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/7.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/8.png",
    "https://alfatoro.com/wp-content/uploads/2025/06/1.png",
  ];

  const mobileProofImages = [
    "https://alfatoro.com/wp-content/uploads/2025/07/Debra-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/Erin-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/amanda-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/Kevin-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/Suraj-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/Sewell-mobile.png",
    "https://alfatoro.com/wp-content/uploads/2025/07/ajin-mobile.png",
  ];

  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    const links = document.querySelectorAll("a[data-keep-params]");

    links.forEach((link) => {
      const url = new URL(link.href);
      params.forEach((value, key) => url.searchParams.set(key, value));
      link.href = url.toString();
    });
  });
</script>

<div class="hero">
  <div class="container">
    <div class="inner-container">
      <h1>
        The <span style="color: yellow;">#1 Shadow Trading System</span> Where
        You Simply <span style="color: yellow;">Copy Our Trades</span> to
        <span style="color: yellow;">Grow Your Account</span>
      </h1>
      <p>
        Just copy every trade—entries, exits, and setups—so you grow your skills
        and your account side by side.
      </p>

      <div class="hero__vsl-wrapper">
        <div class="hero__vsl-subheading">
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-volume2-icon lucide-volume-2"
              ><path
                d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
              /><path d="M16 9a5 5 0 0 1 0 6" /><path
                d="M19.364 18.364a9 9 0 0 0 0-12.728"
              /></svg
            >Click 'Play' To Learn How
          </p>
        </div>
        <div class="hero__vsl">
          <iframe
            src="https://www.youtube.com/embed/sfW4gWEPPnk?si=-fXniCSsBvhBhvkB&rel=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <a class="button" href={checkoutUrl} data-keep-params>Join Now</a>

      <div class="look-down">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-down-icon lucide-chevron-down"
          ><path d="m6 9 6 6 6-6" /></svg
        >
      </div>
    </div>
  </div>
</div>

<div class="social-proof">
  <div class="container">
    <div class="inner-container">
      <div class="social-proof__list desktop">
        {#each socialProofImages as url}
          <div class="social-proof__item">
            <img src={url} loading="lazy" />
          </div>
        {/each}
      </div>
      <div class="social-proof__list mobile">
        {#each mobileProofImages as url}
          <div class="social-proof__item">
            <img src={url} loading="lazy" />
          </div>
        {/each}
      </div>
      <a class="button" href={checkoutUrl} data-keep-params>Join Now</a>
    </div>
  </div>
</div>

<style lang="scss">
  @import "../styles/utils";

  .inner-container {
    margin-left: 0;
    margin-right: 0;
  }

  .button {
    background-color: #3ecf8e;
    display: block;
    margin: auto;
    margin-top: 20px;
    padding: 15px 60px;
    font-size: 16px;
    text-transform: uppercase;
    border-radius: 5px;
    color: #000;
    max-width: 430px;
    text-align: center;

    &:hover {
      text-decoration: none;
    }
  }

  .hero {
    padding: 0 5%;
    position: relative;

    h1 {
      text-align: center;
      margin-bottom: 8px;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: 1px;

      @media (min-width: 1024px) {
        font-size: 55px;
        line-height: 1.2em;
        letter-spacing: normal;
      }
    }

    p {
      color: #99948f;
      text-align: center;
      font-size: 16px;
      line-height: 24px;

      @media (min-width: 1024px) {
        font-size: 18px;
      }
    }
  }

  .hero__vsl-wrapper {
    margin: auto;
    margin-top: 24px;
    max-width: 770px;
  }

  .hero__vsl-subheading {
    background-color: #3ecf8e;
    height: 35px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      color: #000;
      margin: 0;
      font-size: 14px;
    }

    svg {
      transform: translateY(2px);
      margin-right: 4px;
    }
  }

  .hero__vsl {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .look-down {
    text-align: center;
    padding-top: 20px;

    svg {
      animation: subtle-bounce 0.5s ease-out infinite;
    }
  }

  .social-proof {
    max-width: 750px;
    margin: auto;
    padding: 0 5%;
    position: relative;

    @media (min-width: 1024px) {
      padding: 0;
    }

    img {
      width: 100%;
      border-radius: 20px;
    }

    .social-proof__list {
      display: flex;
      flex-direction: column;
      gap: 20px;

      &.desktop {
        display: none;

        @media (min-width: 1024px) {
          display: flex;
        }
      }

      &.mobile {
        @media (min-width: 1024px) {
          display: none;
        }
      }
    }

    .social-proof__item {
      border-radius: 20px;
      overflow: hidden;
    }
  }

  @keyframes subtle-bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4px);
    }
  }
</style>
